export const QA_NAME_APPLICANT_PROFILE_EMAILS = 'applicantProfileEmails'

export const QA_NAME_APPLICANT_PROFILE_EMAILS_COMPOSE =
  'applicantProfileEmailsCompose'

export const QA_NAME_APPLICANT_PROFILE_EMAILS_RETRY =
  'applicantProfileEmailsRetry'

export const QA_NAME_APPLICANT_PROFILE_EMAILS_TABLE = 'applicantEmails'

export const APPLICANT_PROFILE_EMAILS_PAGE_SIZE = 20

export const APPLICANT_PROFILE_EMAILS_DRAFT_PREFIX =
  'rental-portal-applicant-profile-emails'

export const APPLICANT_PROFILE_EMAILS_SKELETON_ROWS = 3

export const ApplicantProfileEmailsColumnName = {
  Participant: 'participant',
  SentAt: 'sent_at',
  Subject: 'subject',
}

export const APPLICANT_PROFILE_EMAILS_COLUMNS_CONFIG = {
  [ApplicantProfileEmailsColumnName.Participant]: {
    index: 0,
    name: ApplicantProfileEmailsColumnName.Participant,
    ordering_field: null,
    title: 'RentalPortal.ApplicantProfileEmailsParticipantColumnKey',
    visible: true,
    width: 240,
  },
  [ApplicantProfileEmailsColumnName.SentAt]: {
    index: 2,
    name: ApplicantProfileEmailsColumnName.SentAt,
    ordering_field: null,
    title: 'RentalPortal.ApplicantDocumentDateColumnKey',
    visible: true,
    width: 200,
  },
  [ApplicantProfileEmailsColumnName.Subject]: {
    index: 1,
    name: ApplicantProfileEmailsColumnName.Subject,
    ordering_field: null,
    title: 'RentalPortal.ApplicantProfileEmailsMessageColumnKey',
    visible: true,
  },
}

export const APPLICANT_PROFILE_EMAILS_SEND_ERROR_FIELD = {
  account: 'account',
  files: 'files',
}

export const APPLICANT_PROFILE_EMAILS_NO_ADDRESS_REASON = 'no_address'
